import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const eventRegistration = `
<mjml>
  <mj-head>
    <mj-title>Registration Confirmed | Bihar Samaj Event</mj-title>
    <mj-preview>Your event registration has been confirmed. Here are your details.</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
      <mj-section padding="0px" />
    </mj-attributes>
    <mj-style>
      .rounded-border { border-radius: 8px; overflow: hidden; }
      .ticket-details td { padding: 10px 0; }
      .ticket-details { width: 100%; }
      .ticket-details tr { border-bottom: 1px solid #e0e0e0; }
      .ticket-number { letter-spacing: 2px; }
      .qr-box { border: 1px dashed #99CC66; border-radius: 12px; padding: 15px; }
      @media (max-width: 480px) {
        .mobile-block { display: block !important; width: 100% !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#f9f9f9">
    ${TRANSACTIONAL_HEADER(
      "Registration Confirmed",
      "We're excited to have you join us!"
    )}
    
    <!-- Hero Banner -->
    <mj-section padding="0">
      <mj-column>
        <mj-image src="https://bsauh-uae.s3.ap-south-1.amazonaws.com/bsauh-gallery-bucket/bsadholi.png" alt="Event Banner" width="600px" css-class="rounded-border" padding-top="0" />
      </mj-column>
    </mj-section>
    
    <!-- Confirmation Message -->
    <mj-section background-color="#ffffff" padding="30px 20px 20px" css-class="rounded-border" border-radius="8px">
      <mj-column>
        <mj-text font-size="22px" color="#336633" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Thank you for registering for our upcoming event. Your registration has been confirmed, and we're looking forward to seeing you there!</mj-text>
        <mj-text font-size="16px" font-style="italic" color="#666666" font-family="Arial, sans-serif" padding-bottom="20px">"We may not live in Bihar, Jharkhand, and Uttar Pradesh, but their spirit lives in us."</mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Ticket Information -->
    <mj-section background-color="#ffffff" padding="0px 20px 20px" css-class="rounded-border">
      <mj-column>
        <mj-text font-size="20px" color="#1a2310" font-family="Arial, sans-serif" font-weight="bold" align="center" padding-bottom="20px">Your Ticket Details</mj-text>
        
        <!-- Fancy Ticket Number Display -->
        <mj-text align="center" color="#336633" font-size="24px" font-weight="bold" font-family="monospace" css-class="ticket-number" padding-bottom="20px">#BSA-2023-{{registration_id}}</mj-text>
        
        <!-- Premium Divider -->
        <mj-divider border-width="1px" border-color="#e0e0e0" padding-top="0" padding-bottom="20px" />
        
        <!-- Ticket Details Table -->
        <mj-table css-class="ticket-details">
          <tr>
            <td style="width: 40%; color: #777777;">Event</td>
            <td style="width: 60%; color: #333333; font-weight: bold;">{{event_name}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Date & Time</td>
            <td style="width: 60%; color: #333333;">{{event_date}} at {{event_time}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Venue</td>
            <td style="width: 60%; color: #333333;">{{event_venue}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Ticket Type</td>
            <td style="width: 60%; color: #333333;">{{ticket_type}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Quantity</td>
            <td style="width: 60%; color: #333333;">{{ticket_quantity}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Total Amount Due</td>
            <td style="width: 60%; color: #336633; font-weight: bold; font-size: 18px;">AED {{total_amount}}</td>
          </tr>
          <tr>
            <td style="width: 40%; color: #777777;">Order Reference</td>
            <td style="width: 60%; color: #333333;">ORD-{{order_reference}}</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    
    <!-- QR Code Section -->
    <mj-section background-color="#ffffff" padding="0px 20px 30px" css-class="rounded-border">
      <mj-column width="40%" css-class="mobile-block">
        <mj-image src="https://bsauh-uae.s3.ap-south-1.amazonaws.com/bsauh-gallery-bucket/logo.png" alt="QR Code" width="150px" css-class="qr-box" />
      </mj-column>
      <mj-column width="60%" css-class="mobile-block">
        <mj-text font-size="18px" color="#336633" font-weight="bold">Easy Entry with QR Code</mj-text>
        <mj-text font-size="14px" color="#555555">
          Simply show this QR code at the entrance for quick and seamless entry to the event. You can print this email or present it on your mobile device.
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- What to Bring -->
    <mj-section background-color="#f9f9f9" padding="20px" border-radius="8px" border="1px dashed #99CC66">
      <mj-column>
        <mj-text font-size="18px" color="#336633" font-weight="bold" padding-bottom="10px">Things to Remember</mj-text>
        <mj-text font-size="14px" color="#555555" padding-top="0">
          • Please arrive 15 minutes before the event starts<br>
          • Bring this confirmation email (digital or printed)<br>
          • A valid ID may be required at entry<br>
          • Check weather conditions and dress appropriately<br>
          • Parking is available at the venue
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- Calendar Add Button -->
    <mj-section padding="20px 0">
      <mj-column width="48%" css-class="mobile-block">
        <mj-button background-color="#336633" color="#ffffff" font-size="14px" border-radius="4px" href="#" width="100%">
          <img src="https://bsauh-uae.s3.ap-south-1.amazonaws.com/bsauh-gallery-bucket/logo.png" width="20" height="20" style="vertical-align: middle; margin-right: 8px;" />
          Add to Google Calendar
        </mj-button>
      </mj-column>
      <mj-column width="48%" css-class="mobile-block">
        <mj-button background-color="#336633" color="#ffffff" font-size="14px" border-radius="4px" href="#" width="100%">
          <img src="https://bsauh-uae.s3.ap-south-1.amazonaws.com/bsauh-gallery-bucket/logo.png" width="20" height="20" style="vertical-align: middle; margin-right: 8px;" />
          Add to Apple Calendar
        </mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "eventRegistration",
  name: "Event Registration Confirmation",
  category: "transactional",
  purpose: "transactional" as const,
  description:
    "A premium, professional confirmation email for event registrations with QR code, ticket details, and reminder information.",
  features: [
    "Responsive ticket details layout",
    "QR code for quick entry",
    "Key event information",
    "Calendar integration buttons",
    "Things to remember section",
  ],
  subject: "Registration Confirmed | Copilotly Event",
  subTitle:
    "Your event registration has been confirmed. Here are your details.",
  mjmlTemplate: eventRegistration,
  tags: ["transactional", "event", "registration", "confirmation"],
};
